import { FormHelperText } from '@mui/material';

import { GDMFormHelperTextComponent } from './GDMFormHelperText.type';

/* TODO: Implement component using GDM default design */
const GDMFormHelperText: GDMFormHelperTextComponent = props => <FormHelperText {...props} />;

export default GDMFormHelperText;
